// import React, { useState, useEffect } from "react";
// import { FileText, Download } from "lucide-react";
// import { getUploadUrl } from "./apiConstants";

// const DownloadSection = ({
//   title = "Cut Sheet",
//   description = "Learn about 2.0 RMC Plus features",
//   backgroundImage,
//   buttonText = "Download Now",
//   linkField = "others_link",
//   products = [],
//   isLoading = false,
//   filterBySlug = null,
//   showOnlyFirst = false,
// }) => {
//   const [downloads, setDownloads] = useState([]);

//   useEffect(() => {
//     if (products && products.length > 0) {
//       let filteredProducts = products.filter(
//         (product) => product[linkField] && product[linkField] !== ""
//       );

//       if (filterBySlug) {
//         filteredProducts = filteredProducts.filter(
//           (product) => product.slug === filterBySlug
//         );
//       }

//       if (showOnlyFirst && filteredProducts.length > 0) {
//         filteredProducts = [filteredProducts[0]];
//       }

//       const uniqueDownloads = filteredProducts.map((product, index) => ({
//         id: product.id || index,
//         name: product.title || product.catalogue_name || "Download",
//         link: product[linkField],
//       }));

//       setDownloads(uniqueDownloads);
//     }
//   }, [products, linkField, filterBySlug, showOnlyFirst]);

//   const handleDownload = (download) => {
//     const cleanPath = download.link.replace(/^\/+/, "");
//     const downloadUrl = getUploadUrl(cleanPath);
//     window.open(downloadUrl, "_blank");
//   };

//   return (
//     <div className="mb-0 rounded-lg overflow-hidden shadow-sm ">
//       <div className="flex flex-col md:flex-row">
//         {/* Left side - Image */}
//         <div className="flex bg-[#E6E6E6;] w-full md:w-[620px] px-4 md:px-[220px] py-8 md:py-0 justify-center items-center">
//           <img
//             src={backgroundImage}
//             alt={title}
//             className="w-full h-auto max-w-[240px] object-contain"
//           />
//         </div>

//         {/* Right side - Content */}
//         <div className="flex flex-1 bg-[#F8F8F8] px-6 py-5 md:px-20 md:py-10 flex-col justify-center items-start gap-6">
//           <div className="flex flex-col gap-2 self-stretch">
//             <h2 className="text-[#1C1C1C] text-[22px] font-semibold leading-[32px] font-['Poppins']">
//               {title}
//             </h2>
//             <p className="text-[#4A4C56] text-[16px] font-normal leading-[24px] font-['Poppins']">
//               {description}
//             </p>
//           </div>

//           {isLoading ? (
//             <div className="flex items-center gap-2 text-gray-500">
//               <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
//               <span>Loading...</span>
//             </div>
//           ) : downloads.length > 0 ? (
//             <div className="flex flex-col gap-2 w-full">
//               {downloads.map((download) => (
//                 <button
//                   key={download.id}
//                   onClick={() => handleDownload(download)}
//                   className="inline-flex items-center gap-2 px-4 py-2 bg-[#016FFC] hover:bg-[rgb(2,95,218)] text-white rounded-md transition-colors font-['Poppins'] font-medium text-[14px] leading-[20px] w-fit"
//                 >
//                   <svg
//                     width="16"
//                     height="16"
//                     viewBox="0 0 16 16"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="flex-shrink-0"
//                   >
//                     <path
//                       d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                     <path
//                       d="M4.66602 6.66602L7.99935 9.99935L11.3327 6.66602"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                     <path
//                       d="M8 10V2"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                   {buttonText}
//                 </button>
//               ))}
//             </div>
//           ) : (
//             <div className="text-gray-500 text-sm">No downloads available</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DownloadSection;
import React, { useState, useEffect } from "react";
import { getUploadUrl } from "./apiConstants";

const DownloadSection = ({
  title = "Cut Sheet",
  description = "Learn about 2.0 RMC Plus features",
  backgroundImage,
  buttonText = "Download Now",
  linkField = "others_link",
  products = [],
  isLoading = false,
  filterBySlug = null,
  showOnlyFirst = false,
  backgroundColor = "#F8F8F8",
}) => {
  const [downloads, setDownloads] = useState([]);

  useEffect(() => {
    if (products && products.length > 0) {
      let filteredProducts = products.filter(
        (product) => product[linkField] && product[linkField] !== ""
      );

      if (filterBySlug) {
        filteredProducts = filteredProducts.filter(
          (product) => product.slug === filterBySlug
        );
      }

      if (showOnlyFirst && filteredProducts.length > 0) {
        filteredProducts = [filteredProducts[0]];
      }

      const uniqueDownloads = filteredProducts.map((product, index) => ({
        id: product.id || index,
        name: product.title || product.catalogue_name || "Download",
        link: product[linkField],
      }));

      setDownloads(uniqueDownloads);
    }
  }, [products, linkField, filterBySlug, showOnlyFirst]);

  const handleDownload = (download) => {
    const cleanPath = download.link.replace(/^\/+/, "");
    const downloadUrl = getUploadUrl(cleanPath);
    window.open(downloadUrl, "_blank");
  };

  return (
    <div
      className="w-full flex justify-center items-center rounded-lg overflow-hidden"
      style={{ minHeight: "343px", backgroundColor }}
    >
      <div className="flex flex-col items-center gap-[15px] w-full px-6 py-10 text-center">
        {/* Title */}
        <h2 className="text-[#1C1C1C] text-[22px] font-semibold leading-[32px] font-['Poppins']">
          {title}
        </h2>

        {/* Description */}
        <p className="text-[#4A4C56] text-[16px] font-normal leading-[24px] font-['Poppins'] max-w-[600px]">
          {description}
        </p>

        {/* Download Button / Loading / Empty */}
        {isLoading ? (
          <div className="flex items-center gap-2 text-gray-500">
            <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <span>Loading...</span>
          </div>
        ) : downloads.length > 0 ? (
          <div className="flex flex-col items-center gap-2 w-full">
            {downloads.map((download) => (
              <button
                key={download.id}
                onClick={() => handleDownload(download)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-[#016FFC] hover:bg-[rgb(2,95,218)] text-white rounded-md transition-colors font-['Poppins'] font-medium text-[14px] leading-[20px]"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0"
                >
                  <path
                    d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.66602 6.66602L7.99935 9.99935L11.3327 6.66602"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 10V2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {buttonText}
              </button>
            ))}
          </div>
        ) : (
          <div className="text-gray-500 text-sm">No downloads available</div>
        )}
      </div>
    </div>
  );
};

export default DownloadSection;
